export const faqItems = [
  {
    question: '极速影视真的可以免费观看吗？',
    answer: '是的，极速影视平台上的所有影视内容均可免费在线观看。我们通过广告收入来维持平台运营，用户无需支付任何费用即可享受高清流畅的观影体验。',
  },
  {
    question: '为什么极速影视的播放速度这么快？',
    answer: '极速影视采用了先进的CDN内容分发网络和智能码率自适应技术。我们的服务器分布在全国多个节点，能够根据用户的网络状况自动选择最优节点，实现秒开即播、极速不缓冲的流畅体验。',
  },
  {
    question: '极速影视支持哪些设备观看？',
    answer: '极速影视支持所有主流设备，包括电脑（Windows/Mac）、手机（iOS/Android）、平板电脑以及智能电视。您可以通过浏览器直接访问，无需下载任何APP即可享受流畅的观影体验。',
  },
  {
    question: '视频画质如何？支持高清吗？',
    answer: '极速影视提供多种画质选择，包括标清、高清（720P）、全高清（1080P），部分热门内容甚至支持4K超清画质。系统会根据您的网络状况智能推荐合适的画质，您也可以手动切换。',
  },
  {
    question: '如何找到我想看的影视内容？',
    answer: '您可以通过首页的分类导航浏览不同类别的影视内容，也可以使用顶部的搜索功能直接搜索您想看的剧名或电影名。此外，首页的热门推荐和最新上线版块也能帮助您发现精彩内容。',
  },
  {
    question: '极速影视的内容更新频率如何？',
    answer: '我们每天都会更新最新的影视内容，热门电视剧一般在播出后2小时内即可上线，电影也会在院线下映后尽快上线。您可以通过"最新上线"版块查看每日更新的内容。',
  },
  {
    question: '观看过程中遇到卡顿怎么办？',
    answer: '如遇卡顿，您可以尝试以下方法：1）切换较低画质观看；2）检查您的网络连接；3）刷新页面重新加载；4）避开网络高峰时段。极速影视的智能缓冲技术能最大程度减少卡顿现象。',
  },
  {
    question: '需要注册账号才能观看吗？',
    answer: '不需要！极速影视支持免注册观看，您可以直接访问网站开始追剧。不过，注册账号后可以享受收藏影片、同步观看历史、跨设备续播等更多便捷功能。',
  },
];